var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-5 -5 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M9.909,2.789a3.466,3.466,0,0,0-.22-1.151A2.43,2.43,0,0,0,8.3.25,3.475,3.475,0,0,0,7.15.03C6.642.006,6.481,0,5.193,0S3.744.006,3.238.028a3.467,3.467,0,0,0-1.151.22A2.315,2.315,0,0,0,1.246.8,2.335,2.335,0,0,0,.7,1.636a3.475,3.475,0,0,0-.22,1.151c-.024.508-.03.669-.03,1.957S.455,6.193.477,6.7A3.466,3.466,0,0,0,.7,7.85,2.43,2.43,0,0,0,2.086,9.238a3.476,3.476,0,0,0,1.151.22c.506.022.667.028,1.955.028S6.64,9.48,7.146,9.458A3.465,3.465,0,0,0,8.3,9.238,2.426,2.426,0,0,0,9.685,7.85,3.478,3.478,0,0,0,9.906,6.7c.022-.506.028-.667.028-1.955S9.931,3.295,9.909,2.789ZM9.055,6.662a2.6,2.6,0,0,1-.163.88,1.574,1.574,0,0,1-.9.9,2.609,2.609,0,0,1-.88.163c-.5.022-.65.028-1.916.028s-1.418-.006-1.916-.028a2.6,2.6,0,0,1-.88-.163,1.46,1.46,0,0,1-.545-.354A1.475,1.475,0,0,1,1.5,7.544a2.61,2.61,0,0,1-.163-.88c-.022-.5-.028-.65-.028-1.916s.006-1.418.028-1.916a2.6,2.6,0,0,1,.163-.88,1.442,1.442,0,0,1,.356-.545A1.473,1.473,0,0,1,2.4,1.053a2.611,2.611,0,0,1,.88-.163c.5-.022.65-.028,1.916-.028S6.614.867,7.113.889a2.6,2.6,0,0,1,.88.163,1.459,1.459,0,0,1,.545.354,1.474,1.474,0,0,1,.354.545,2.611,2.611,0,0,1,.163.88c.022.5.028.65.028,1.916S9.077,6.162,9.055,6.662Zm0,0",
    transform: "translate(-0.449 0)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M127.386,124.5a2.437,2.437,0,1,0,2.437,2.437A2.437,2.437,0,0,0,127.386,124.5Zm0,4.018a1.581,1.581,0,1,1,1.581-1.581A1.581,1.581,0,0,1,127.386,128.518Zm0,0",
    transform: "translate(-122.642 -122.193)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M363.587,89.17a.569.569,0,1,1-.569-.569A.569.569,0,0,1,363.587,89.17Zm0,0",
    transform: "translate(-355.741 -86.96)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c34473a00e75b9926e3695f6a7867f1b.svg";
export { ForwardRef as ReactComponent };